import { motion } from "framer-motion";
import {
  Map,
  Layers,
  LineChart,
  Grid3x3,
  FileCode2,
  Globe,
  FileText,
  Calculator,
  Boxes,
  Waypoints,
  Mountain,
  Files,
} from "lucide-react";

const deliverables = [
  { icon: Map, name: "Orthomosaic" },
  { icon: Layers, name: "DEM" },
  { icon: Layers, name: "DSM" },
  { icon: LineChart, name: "Contours" },
  { icon: Grid3x3, name: "Point Cloud" },
  { icon: FileCode2, name: "CAD Files" },
  { icon: Globe, name: "KML" },
  { icon: Waypoints, name: "LAS" },
  { icon: Mountain, name: "GeoTIFF" },
  { icon: FileText, name: "Reports" },
  { icon: Calculator, name: "Volume Reports" },
  { icon: Boxes, name: "3D Models" },
];

export const Deliverables = () => {
  return (
    <section id="deliverables" className="py-24 bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-widest text-[#8b8f99]">Deliverables</span>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-black text-[#10193f]">
            Formats your engineers can use immediately
          </h2>
        </div>
        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {deliverables.map((d, i) => {
            const Icon = d.icon;
            return (
              <motion.div
                key={d.name + i}
                data-testid={`deliverable-${i}`}
                initial={{ opacity: 0, scale: 0.97 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: (i % 6) * 0.05 }}
                className="group flex flex-col items-center justify-center rounded-sm border border-gray-200 p-6 text-center hover:bg-[#10193f] transition-colors duration-300"
              >
                <Icon className="h-7 w-7 text-[#10193f] group-hover:text-white transition-colors" strokeWidth={1.6} />
                <span className="mt-3 font-heading text-sm font-bold text-[#10193f] group-hover:text-white transition-colors">
                  {d.name}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
